import { Component, inject, input } from "@angular/core";
import { RouterLink } from "@angular/router";
import { NetworkFeatureToggle } from "@kno2/common/directives";
import { APP_CONFIG_TOKEN } from "@kno2/core/config";
import { UserProfile } from "@kno2/core/session/user-profile.model";
import { FeatureToggleDirective } from "@kno2/shared/features";

@Component({
    selector: "kno2-settings-menu",
    imports: [FeatureToggleDirective, NetworkFeatureToggle, RouterLink],
    templateUrl: "./settings-menu.component.html"
})
export class SettingsMenuComponent {
    private readonly appConfig = inject(APP_CONFIG_TOKEN);

    protected currentUser = input.required<UserProfile>();

    protected isPrivateLabel = false;
    protected isLicensedOrg = false;

    public ngOnInit(): void {
        this.isPrivateLabel = this.appConfig.brand !== "Kno2";
        this.isLicensedOrg = this.currentUser().resellerType === "Licensing";
    }
}
